import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { HELP_DESK_DEFAULT_VIEW } from '../constants/helpDesk';

const { persistAtom } = recoilPersist();

export const selectedBranches = atom({ key: 'selectedBranches', default: null });

export const isChatOpen = atom({ key: 'isChatOpen', default: false });

export const selectedBranch = atom({ key: 'selectedBranch', default: null });

export const viewAsClient = atom({ key: 'viewAsClient', default: false });

export const toaster = atom({ key: 'toaster', default: [] });

export const confetti = atom({ key: 'confetti', default: false });

export const selectedEmployee = atom({ key: 'selectedEmployee', default: null });

export const chatCount = atom({ key: 'chatCount', default: null });

export const openChatRoom = atom({ key: 'openChatRoom', default: {} });

export const controlledColumnsMenuOpenData = atom({ key: 'controlledColumnsMenuOpenData', default: null });

export const fileUpload = atom({ key: 'fileUpload', default: 0 });

export const chatIframeRef = atom({ key: 'chatIframeRef', default: null });

export const auditLogSidebarRef = atom({ key: 'auditLogSidebarRef', default: { isOpen: false, payload: {} } });

export const requestsModal = atom({ key: 'requestsModal', default: false });

/**
 * Optional request-id filter for the requests modal, as `{ requestIds: number[] }` or null.
 * Kept separate from `requestsModal` on purpose: that atom is a plain boolean synced to the
 * `?requests` query param by useSyncDashboardUrl, so widening it to an object would put a filter
 * payload in the URL. Openers that want a filtered list set both; everything else stays unfiltered.
 */
export const requestsModalFilter = atom({ key: 'requestsModalFilter', default: null });

export const plansModal = atom({ key: 'plansModal', default: false });

export const openHelpCenter = atom({ key: 'openHelpCenter', default: false });

export const premiumModal = atom({ key: 'premiumModal', default: null });

export const refreshNeededModal = atom({ key: 'refreshNeeded', default: false });

export const helpDeskSidePanel = atom({ key: 'helpDeskSidePanel', default: { isOpen: false, ticketId: null } });

/** Shared help-desk selected tab between side panel and full-page list. */
export const helpDeskTicketsListState = atom({
  key: 'helpDeskTicketsListState',
  default: {
    view: HELP_DESK_DEFAULT_VIEW
  }
});

export const chatFilters = atom({
  key: 'chatFilters',
  default: { tagIds: [], branchIds: [], statuses: [] },
  effects_UNSTABLE: [persistAtom]
});
